
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateConnectorConfigDtoFormGroup() {
return new FormGroup({
    active: new FormControl<boolean | undefined>(undefined),
    syncIntervalMinutes: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(10080)]),
    settings: new FormControl<any | undefined>(undefined),
})
;
}
      